import { render } from "./ConfirmOrder.vue?vue&type=template&id=54f02824&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=54f02824&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=54f02824&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f02824"]])

export default __exports__